import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'user-profile',
    loadChildren: () => import('./pages/user-profile/user-profile.module').then(m => m.UserProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'intro',
    loadChildren: () => import('./pages/intro/intro.module').then(m => m.IntroPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'qr/:id',
    loadChildren: () => import('./pages/qr-code/qr-code.module').then(m => m.QrCodePageModule)
  },
  {
    path: 'ap-img/:id',
    loadChildren: () => import('./pages/qr-code/qr-code.module').then(m => m.QrCodePageModule)
  },
  {
    path: 'anonymous/view-post/:postType/:postId/:type',
    loadChildren: () => import('./pages/anonym-pages/view-post/view-post.module').then(m => m.ViewPostPageModule)
  },
  {
    path: 'share/:id',
    loadChildren: () => import('./pages/share/share.module').then(m => m.SharePageModule),
  },
  {
    path: 'app/map-moment/:id',
    loadChildren: () => import('./pages/map-moment/map-moment.module').then(m => m.MapMomentPageModule)
  },
  {
    path: 'app/point-of-action-details/:id',
    loadChildren: () => import('./pages/point-of-action-details/point-of-action-details.module').then(m => m.PointOfActionDetailsPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
